declare const gadgets: any;
declare const finesse: any;

import { Resolver } from 'one-core';
const crypto = require('crypto');

export const loader = (
    options: any = {},
    init: (opts: any) => void,
) => {
    return new Promise((resolve, reject) => {
        const { HubSettings } = gadgets;
        HubSettings.onConnect = async () => {
            let base: string;
            // Finesse container re-writes the urls included
            // in main gadget mark up (html)
            const img = document.getElementById(
                'L_5CC6352F51BC44D8BE60C902B79C442C',
            ) as HTMLImageElement;

            if (img) {
                var src = img.src;
                const index = src.lastIndexOf('__loc.png');
                if (index !== -1) {
                    base = src.substring(0, index);
                }
            }

            const resolver: Resolver = (base) ?
                ((urlbase: string) => (`${base}${urlbase}`)) :
                ((urltemp: string) => (urltemp));

            const { url, log } = options;
            const resolved = resolver(url);

            const {
                params = {
                    cache: 'no-cache',
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
            } = options;

            fetch(resolved, params).then((resp: any) => {
                if (!(resp.ok)) {
                    const { status } = resp;
                    reject({
                        message: 'Error fetching settings',
                        description: `status: ${status} url: ${resolved}`
                    });
                } else {
                    resp.json().then((settings: any) => {
                        const {
                            gadget: { Config },
                            restservices: { User },
                            cslogger: { ClientLogger },
                            clientservices: { ClientServices },
                        } = finesse;

                        // initialize the client servvices
                        ClientServices.init(Config);

                        // initailize the logger
                        const { Hub } = gadgets;
                        ClientLogger.init(Hub, Config.id, Config);

                        new User({
                            id: Config.id,
                            onLoad: (user: any) => {
                                init({
                                    user,
                                    resolver,
                                    settings,
                                });
                            },
                        });

                        const {
                            containerservices: {
                                ContainerServices
                            },
                        } = finesse;

                        // initiailize the container
                        // and adjust the gadget height
                        const services = ContainerServices.init();
                        services.addHandler(ContainerServices.Topics.ACTIVE_TAB, () => {
                            const { window: gadWin } = gadgets;
                            // activate the current tab
                            if ((gadWin) && (gadWin.adjustHeight)) {
                                gadWin.adjustHeight();
                            }
                        });
                        services.addHandler(ContainerServices.Topics.GADGET_VIEW_CHANGED_EVENT, () => {
                            const { window: gadWin } = gadgets;
                            // activate the current tab
                            if ((gadWin) && (gadWin.adjustHeight)) {
                                gadWin.adjustHeight();
                            }
                        });
                        services.makeActiveTabReq();
                        resolve({
                            settings,
                            services,
                        });
                    }).catch((exp: any) => {
                        log.error(
                            "one-gadget-loader",
                            "Activetabrequest-invalid content",{
                                exp
                            }
                        );
                        reject({
                            message: 'Error fetching settings, invalid content',
                            description: exp.message,
                        });
                    });
                }
            }).catch((exp: any) => {
                log.error(
                    "one-gadget-loader",
                    "Activetabreq-server unreachable",{
                        exp
                    }
                );
                reject({
                    message: 'Error fetching settings, server unreachable',
                    description: `server unreachable, url: ${resolved}`
                });
            });
        };
    });
}
export const adjustHeight = () =>{
    const { window: gadWin } = gadgets;
    // activate the current tab
    if ((gadWin) && (gadWin.adjustHeight)) {
        gadWin.adjustHeight();
    }
}
export const adjustHeightWithParams = (height: number) =>{
    const { window: gadWin } = gadgets;
    // activate the current tab
    if ((gadWin) && (gadWin.adjustHeight) && height && height > 0) {
        gadWin.adjustHeight(height);
    }else{
        gadWin.adjustHeight();
    }
}

export const validateHandler = (handler: any) => {
    if (handler === undefined || typeof handler === "function") {
        return handler;
    } else {
        throw new Error("handler must be a function");
    }
}


export const handleResponse = ( handlers: any ) =>
{
	return function (response: any) {
		console.debug("VisQ - handleResponse(): The response status code is: " + response.rc);
		
		// Send the response to the success handler if the http status
		// code is 200 or 202. Send the response to the error handler
		// otherwise.
		if ((response.rc === 200 || response.rc === 202) && handlers.success) {
			console.debug("VisQ - handleResponse(): Got a successful response.");
			handlers.success(response);
		} else if (handlers.error) {
			console.debug("VisQ - handleResponse(): Got a failure response.");
			handlers.error(response);
		} else {
			console.debug("VisQ - handleResponse(): Missing the success and/or error handler.");
		}
	};
}

export const proxyRequestThruGadgetsIO = ( url: any, options: any, handlers: any ) =>
{
	let params: any, uuid: any;
	console.debug("VisQ - proxyRequestThruGadgetsIO() enter");
	const { window: gadWin } = gadgets;
	// Protect against null dereferencing of options & handlers allowing its (nonexistant) keys to be read as undefined
	params = {};
	options = options || {};
	handlers.success = validateHandler(handlers.success);
	handlers.error = validateHandler(handlers.error);

	// Request Headers
	params[gadgets.io.RequestParameters.HEADERS] = {};

	// HTTP method is a passthrough to gadgets.io.makeRequest
	params[gadgets.io.RequestParameters.METHOD] = options.method;

	if (options.method === "GET") {
		// Disable caching for GETs
		if (url.indexOf("?") > -1) {
			url += "&";
		} else {
			url += "?";
		}
		url += "nocache=" + new Date().getTime();
	} else {
		// Generate a requestID and add it to the headers
        uuid = crypto.randomBytes(16);
		params[gadgets.io.RequestParameters.HEADERS].requestId = uuid;
		params[gadgets.io.RequestParameters.GET_FULL_HEADERS] = "true";
	}
	
	// Add authorization to the request header if provided
	if(options.authorization) {
		params[gadgets.io.RequestParameters.HEADERS].Authorization = options.authorization;
	}
    // Content Type
	params[gadgets.io.RequestParameters.HEADERS]["Content-Type"] = options.contentType;
	// Add content type & body if content body is provided
	if (options.content) {
		// Content Type
		//params[gadgets.io.RequestParameters.HEADERS]["Content-Type"] = options.contentType;
		// Content
		params[gadgets.io.RequestParameters.POST_DATA] = options.content;
	}

	// Call the gadgets.io.makereqest function with the encoded url
	console.debug("VisQ - makeRequest(): Making a REST API request to: " + url);
	gadgets.io.makeRequest( encodeURI(url), handleResponse(handlers), params );
}


